import {ReactElement} from "react";

export function Logo(props: any): ReactElement {
    const height = props.height as string ?? '64px';
    const isLight = props.light as boolean ?? true;

    return (<div style={props.style}>
        <svg className={props.className} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 521.78 521.16" xmlSpace="preserve" style={{height: height ?? props.style.height}}>
            <g>
                <path style={{fill: isLight ? '#D9D9D9': '#272727'}} d="M393.37,255.83v-53.78h114.52v-10H265.81v-85.67h194.16v-10H61.65v10h194.16v85.67H13.73v10h114.52v53.78H5.69
		c0,1.98,0,3.95,0,5.93c0,1.36,0,2.71,0,4.07c62.11,0,124.23,0,186.34,0v134.82c0,2.76,2.24,5,5,5s5-2.24,5-5V265.83h53.79v250.11
		c0,2.77,2.23,5,4.99,5c2.76,0,5.01-2.28,5.01-5.05c0.01,0,0,0,0,0V265.83h53.77v134.82c0,2.76,2.24,5,5,5c2.77,0,5-2.24,5-5V265.83
		h186.34v-10H393.37z M383.37,255.83H138.25v-53.78h245.12V255.83z"/>
                <path style={{fill: 'none', stroke: isLight ? '#D9D9D9' : '#272727', strokeWidth: '10', strokeMiterlimit: '10'}}
                      d="M515.93,265.83c0-143.56-114.22-259.93-255.12-259.93S5.69,122.27,5.69,265.83"/>
            </g>
        </svg>
        </div>
    )
}